class RevolverCarousel extends HTMLElement {
  constructor() {
    super();
    this._step = 0;
    this._scrollAccum = 0;
    this._touchStartY = 0;
  }

  connectedCallback() {
    this._wheel = this.querySelector('.revolver-wheel');
    this._infoTitle = this.querySelector('.revolver-info-panel__title');
    this._infoPrice = this.querySelector('.revolver-info-panel__price');
    this._infoPanel = this.querySelector('.revolver-info-panel');
    this._section = this.closest('.revolver-section');

    // Collect all unique products from original cards
    const originals = Array.from(this._wheel.querySelectorAll('.revolver-card'));
    this._products = originals.map(c => ({
      href:   c.getAttribute('href'),
      title:  c.dataset.title,
      price:  c.dataset.price,
      imgSrc: c.querySelector('img') ? c.querySelector('img').src : null,
      imgAlt: c.querySelector('img') ? c.querySelector('img').alt : '',
    }));
    this._n = this._products.length;

    // Always 6 slots on mobile (or actual count if >= 6), actual count on desktop
    const isMobile = window.innerWidth < 750;
    const SLOTS = isMobile ? Math.max(this._n, 6) : this._n;

    // Replace originals with empty slots
    originals.forEach(c => c.remove());
    for (let i = 0; i < SLOTS; i++) {
      const a = document.createElement('a');
      a.className = 'revolver-card';
      a.innerHTML = `<div class="revolver-card__image"><img src="" alt="" width="220" height="260" loading="lazy"></div>`;
      this._wheel.appendChild(a);
    }

    this.cards = Array.from(this._wheel.querySelectorAll('.revolver-card'));
    this._total = this.cards.length;

    // Assign initial products: spread evenly so no two adjacent visible slots match
    // For 3 products in 6 slots: [0,1,2,3%3,4%3,5%3] = [0,1,2,0,1,2] — duplicates are 3 apart (opposite side)
    this._slotMap = this.cards.map((_, i) => i % this._n);
    this._applySlotMap();

    this._onWheel = this._onWheel.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this._section.addEventListener('wheel', this._onWheel, { passive: false });
    this._section.addEventListener('touchstart', this._onTouchStart, { passive: true });
    this._section.addEventListener('touchmove', this._onTouchMove, { passive: false });

    this.cards.forEach((card, i) => {
      card.addEventListener('click', (e) => {
        if (!card.classList.contains('is-active')) {
          e.preventDefault();
          e.stopPropagation();
          this._step = -i;
          this._render();
        }
      });
    });

    this._render();
  }

  _applySlotMap() {
    this.cards.forEach((card, i) => {
      const p = this._products[this._slotMap[i]];
      card.setAttribute('href', p.href);
      card.dataset.title = p.title;
      card.dataset.price = p.price;
      const img = card.querySelector('img');
      if (img && p.imgSrc) { img.src = p.imgSrc; img.alt = p.imgAlt; }
    });
  }

  // After each render, check visible slots (those near 9 o'clock) for duplicate hrefs
  // and swap any duplicates with a different product
  _deduplicateVisible(visibleIndices) {
    const seen = new Set();
    visibleIndices.forEach(i => {
      const href = this._products[this._slotMap[i]].href;
      if (seen.has(href)) {
        // Find a product not already visible
        const usedHrefs = new Set(visibleIndices.map(j => this._products[this._slotMap[j]].href));
        for (let k = 0; k < this._n; k++) {
          if (!usedHrefs.has(this._products[k].href)) {
            this._slotMap[i] = k;
            usedHrefs.add(this._products[k].href);
            const p = this._products[k];
            const card = this.cards[i];
            card.setAttribute('href', p.href);
            card.dataset.title = p.title;
            card.dataset.price = p.price;
            const img = card.querySelector('img');
            if (img && p.imgSrc) { img.src = p.imgSrc; img.alt = p.imgAlt; }
            break;
          }
        }
      } else {
        seen.add(href);
      }
    });
  }

  disconnectedCallback() {
    this._section.removeEventListener('wheel', this._onWheel);
    this._section.removeEventListener('touchstart', this._onTouchStart);
    this._section.removeEventListener('touchmove', this._onTouchMove);
  }

  _onWheel(e) {
    e.preventDefault();
    this._scrollAccum += e.deltaY;
    const steps = Math.trunc(this._scrollAccum / 120);
    if (steps !== 0) {
      this._scrollAccum -= steps * 120;
      this._step += steps;
      this._render();
    }
  }

  _onTouchStart(e) {
    this._touchStartY = e.touches[0].clientY;
  }

  _onTouchMove(e) {
    e.preventDefault();
    const dy = this._touchStartY - e.touches[0].clientY;
    this._touchStartY = e.touches[0].clientY;
    this._scrollAccum += dy;
    const steps = Math.trunc(this._scrollAccum / 60);
    if (steps !== 0) {
      this._scrollAccum -= steps * 60;
      this._step += steps;
      this._render();
    }
  }

  _render() {
    if (!this._wheel) return;

    const total    = this._total;
    const slice    = 360 / total;
    const isMobile = window.innerWidth < 750;

    const CARD_W    = isMobile ? 157 : 242;
    const CARD_H    = isMobile ? 165 : 242;
    const CARD_DIAG = Math.ceil(Math.sqrt(CARD_W * CARD_W + CARD_H * CARD_H));
    const GAP_INACTIVE  = isMobile ? 10 : 80;
    const GAP_ACTIVE    = isMobile ? 0 : 10;
    const RADIUS        = Math.ceil((CARD_DIAG + GAP_INACTIVE) / (2 * Math.sin(Math.PI / total)));
    const RADIUS_ACTIVE = RADIUS + GAP_ACTIVE;

    const activeIdx  = ((-this._step % total) + total) % total;
    const wheelAngle = this._step * slice;

    this._wheel.style.transform = `rotate(${wheelAngle}deg)`;

    if (!isMobile) {
      const centerOffset = window.innerWidth / 2 - RADIUS;
      this._wheel.style.right = `${centerOffset}px`;
    } else {
      this._wheel.style.right = '20px';
    }

    if (this._infoPanel) {
      if (!isMobile) {
        const cardRightEdge = window.innerWidth / 2 + CARD_W / 2;
        this._infoPanel.style.left  = `${cardRightEdge + 240}px`;
        this._infoPanel.style.right = 'auto';
        this._infoPanel.style.width = '300px';
      } else {
        const cardRightFromRight = RADIUS - CARD_W / 2;
        const panelWidth = Math.max(100, cardRightFromRight - 32);
        this._infoPanel.style.right = '20px';
        this._infoPanel.style.left  = 'auto';
        this._infoPanel.style.width = `${panelWidth}px`;
      }
    }

    const visibleIndices = [];

    this.cards.forEach((card, i) => {
      const angleDeg = 180 + i * slice;
      const rad      = (angleDeg * Math.PI) / 180;

      const r = (i === activeIdx) ? RADIUS_ACTIVE : RADIUS;
      const x = Math.cos(rad) * r;
      const y = Math.sin(rad) * r;

      card.style.left      = `${x}px`;
      card.style.top       = `${y}px`;
      card.style.transform = `translate(-50%, -50%) rotate(${-wheelAngle}deg)`;

      const isActive = i === activeIdx;
      card.classList.toggle('is-active', isActive);

      if (isActive && this._infoTitle && this._infoPrice) {
        this._infoTitle.textContent = card.dataset.title || '';
        this._infoPrice.textContent = card.dataset.price || '';
      }

      let dist = Math.abs(i - activeIdx);
      if (dist > total / 2) dist = total - dist;
      card.style.opacity = dist === 0 ? 1 : dist === 1 ? 0.5 : 0.2;

      // Visible = active + 1 neighbor each side (the 3 cards on the front arc)
      if (dist <= 1) visibleIndices.push(i);
    });

    // Ensure the 3 visible slots all show different products
    this._deduplicateVisible(visibleIndices);
    // Re-sync info panel in case active slot was reassigned
    const activeCard = this.cards[activeIdx];
    if (this._infoTitle) this._infoTitle.textContent = activeCard.dataset.title || '';
    if (this._infoPrice) this._infoPrice.textContent = activeCard.dataset.price || '';
  }
}

customElements.define('revolver-carousel', RevolverCarousel);


